(() => {
  const menu = document.querySelector('.menu-toggle');
  const navigation = document.querySelector('.navigation');
  const closeMenu = () => { navigation.hidden = true; menu.setAttribute('aria-expanded', 'false'); };
  menu.addEventListener('click', () => { navigation.hidden = !navigation.hidden; menu.setAttribute('aria-expanded', String(!navigation.hidden)); });
  navigation.addEventListener('click', event => { if (event.target.closest('a')) closeMenu(); });
  document.addEventListener('click', event => { if (!event.target.closest('.header')) closeMenu(); });
  document.addEventListener('keydown', event => { if (event.key === 'Escape') closeMenu(); });
  const money = cents => new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR', maximumFractionDigits: cents % 100 ? 2 : 0 }).format(cents / 100);
  const catalogue = window.StudioCatalogue;
  const choices = document.querySelector('#duration-options');
  if (choices) {
    const disclosure = document.querySelector('.rental-disclosure');
    if (disclosure) {
    const mobile = matchMedia('(max-width:760px)');
    let mobileEquipmentOpen = false;
    const updateDisclosure = () => {
      const expanded = !mobile.matches || mobileEquipmentOpen;
      document.querySelector('.rental-layout').classList.toggle('is-collapsed', !expanded);
      disclosure.setAttribute('aria-expanded', String(expanded));
      disclosure.querySelector('span').textContent = expanded ? 'Masquer le matériel et le retour image' : 'Voir le matériel et le retour image';
    };
    disclosure.addEventListener('click', () => { mobileEquipmentOpen = !mobileEquipmentOpen; updateDisclosure(); });
    mobile.addEventListener('change', updateDisclosure);
    updateDisclosure();
    }
    const product = catalogue[document.querySelector('.rental-layout').dataset.product || 'location-studio-t7'];
    const requested = new URLSearchParams(location.search).get('variant');
    const selected = product.variants.find(variant => variant.id === requested && variant.available) || product.variants.find(variant => variant.available);
    const update = variant => {
      document.querySelector('#rental-price').textContent = money(variant.price);
      document.querySelector('#rental-duration').textContent = 'pour ' + variant.label.toLowerCase();
      const nativeVariant = document.querySelector('#t7-booking-variant');
      if (nativeVariant) { nativeVariant.value = variant.id; nativeVariant.dispatchEvent(new Event('change', { bubbles: true })); }
      else document.querySelector('#rental-checkout').href = product.url + '?variant=' + encodeURIComponent(variant.id);
    };
    for (const variant of product.variants) {
      const label = document.createElement('label'); label.className = 'duration-choice';
      const input = document.createElement('input'); input.type = 'radio'; input.name = 'duration'; input.value = variant.id; input.checked = selected?.id === variant.id; input.disabled = !variant.available;
      const text = document.createElement('span'); text.textContent = variant.label.replace(/ Heures?/i, ' h');
      label.append(input, text); choices.append(label);
      input.addEventListener('change', () => update(variant));
    }
    if (selected) update(selected);
    const mainPhoto = document.querySelector('.rental-main-photo');
    document.querySelectorAll('[data-gallery-src]').forEach(button => button.addEventListener('click', () => {
      document.querySelectorAll('[data-gallery-src]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      document.querySelector('#rental-photo').src = button.dataset.gallerySrc;
      document.querySelector('#rental-photo').alt = button.dataset.caption;
      mainPhoto.dataset.pagePhoto = button.dataset.gallerySrc;
      mainPhoto.dataset.caption = button.dataset.caption;
    }));
  }
  const photoDialog = document.querySelector('#page-photo-dialog');
  let photoTrigger;
  document.querySelectorAll('[data-page-photo]').forEach(button => button.addEventListener('click', () => {
    photoTrigger = button;
    photoDialog.querySelector('img').src = button.dataset.pagePhoto;
    photoDialog.querySelector('img').alt = button.dataset.caption;
    photoDialog.querySelector('p').textContent = button.dataset.caption;
    photoDialog.showModal();
  }));
  photoDialog.querySelector('.dialog-close').addEventListener('click', () => photoDialog.close());
  photoDialog.addEventListener('close', () => photoTrigger?.focus());
  photoDialog.addEventListener('click', event => {
    const bounds = photoDialog.getBoundingClientRect();
    if (event.target === photoDialog && (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom)) photoDialog.close();
  });
  document.querySelectorAll('[data-extra]').forEach(card => {
    const product = catalogue[card.dataset.extra];
    const select = card.querySelector('.extra-variant');
    const quantity = card.querySelector('.extra-quantity');
    const checkout = card.querySelector('.extra-checkout');
    const variants = card.dataset.extra === 'prestation-supplementaire' ? [...product.variants].sort((a, b) => a.price - b.price) : product.variants;
    if (select) for (const variant of variants) {
      const option = document.createElement('option'); option.value = variant.id;
      option.textContent = card.dataset.extra === 'prestation-supplementaire' ? money(variant.price) : variant.label + ' — ' + money(variant.price);
      option.disabled = !variant.available;
      select.append(option);
    }
    if (select) select.value = product.variants.find(variant => variant.available).id;
    const update = () => {
      const variant = product.variants.find(item => item.id === select?.value) || product.variants[0];
      const count = quantity ? Number(quantity.value) : 1;
      const valid = Number.isSafeInteger(count) && count >= 1 && variant.available;
      card.querySelector('.extra-price').textContent = valid ? money(variant.price * count) : '—';
      checkout.setAttribute('aria-disabled', String(!valid));
      if (valid) checkout.href = '/cart/' + variant.id + ':' + count;
      else checkout.removeAttribute('href');
    };
    select?.addEventListener('change', update);
    quantity?.addEventListener('input', update);
    checkout.addEventListener('click', event => { if (checkout.getAttribute('aria-disabled') === 'true') event.preventDefault(); });
    update();
  });
})();
